/**
 * User utility functions
 */

/**
 * Get user initials from full name
 *
 * @param name - Full name of the user
 * @returns Initials (up to 2 characters)
 *
 * @example
 * getUserInitials('John Doe') // 'JD'
 * getUserInitials('Jane') // 'JA'
 * getUserInitials('') // 'U'
 */
export const getUserInitials = (name: string): string => {
  if (!name || name.trim().length === 0) {
    return 'U'
  }

  const parts = name.trim().split(/\s+/)

  if (parts.length >= 2) {
    return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase()
  }

  return name.substring(0, 2).toUpperCase()
}
